import { CSSProperties } from 'react'
import { useCSVReader } from 'react-papaparse';

export interface CSVReaderProps {
    csvReader?: CSSProperties
    browseFile?: CSSProperties
    acceptedFile?: CSSProperties
    remove?: CSSProperties
    progressBarBackgroundColor?: CSSProperties
    onUpload: (results: any) => void
    onRemove: (remove: boolean) => void
}

export default function CSVReader(props: CSVReaderProps) {
    const { CSVReader } = useCSVReader();

    const removeItem = () => {
        props.onRemove(true);
    }

    return (
        <CSVReader
            onUploadAccepted={props.onUpload}
        >
            {({
                getRootProps,
                acceptedFile,
                ProgressBar,
                getRemoveFileProps,
            }: any) => {
                let removeFileProps = getRemoveFileProps();
                let onClick = removeFileProps.onClick;
                removeFileProps.onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                    onClick(event);
                    removeItem();
                }
                return (
                <>
                <div style={props.csvReader}>
                    <button type='button' className='btn-primary btn browse-file-btn' {...getRootProps()} style={props.browseFile}>
                    Browse file
                    </button>
                    <div style={props.acceptedFile}>
                        {acceptedFile && acceptedFile.name}
                    </div>
                    {acceptedFile && acceptedFile.name != "" && <>
                        <button  className='btn-primary btn browse-file-btn'{...removeFileProps} style={props.remove}> Remove </button>
                    </>}
                    
                </div>
                <ProgressBar style={props.progressBarBackgroundColor} />
                </>
            )}}
        </CSVReader>
    )
}